(function ($) {
  console.log("here is ada code"); 
  
    $(document).ready(function () {
        // Toggle submenu on click
        $('.submenu-toggle').on('click', function (e) {
            e.preventDefault();

            const $toggle = $(this);
            const expanded = $toggle.attr('aria-expanded') === 'true';

            // Toggle aria-expanded
            $toggle.attr('aria-expanded', !expanded);

            // Toggle submenu
            const $submenu = $toggle.next('.navmenu-submenu');
            $submenu.toggleClass('open', !expanded);
        });

        // 2. Close submenu when pressing ESC
  $(document).on('keydown', function(e) {
    if (e.key === "Escape") {
      const $openToggles = $('.submenu-toggle[aria-expanded="true"]');
      
      if ($openToggles.length > 0) {
        // Reset ARIA attributes
        $openToggles.attr('aria-expanded', 'false');
        
        // Remove the class to actually HIDE the content
        $('.navmenu-submenu, .navmenu-meganav').removeClass('open');
        
        // Accessibility Bonus: Return focus to the button that opened the menu
        $openToggles.first().focus();
      }
    }
  });

  // 3. (Recommended) Close when clicking outside the menu
  $(document).on('click', function(e) {
    if (!$(e.target).closest('[data-navmenu-details]').length) {
       $('.submenu-toggle').attr('aria-expanded', 'false');
       $('.navmenu-submenu, .navmenu-meganav').removeClass('open');
    }
  });
        $('.slideshow-slide__image-wrapper img').attr("alt");
        // Function to prepend labels if not already added
function addPriceLabels() {
    const sale = document.querySelector('.tdf_price_sales');
    const original = document.querySelector('.tdf_price_original');

    if (sale && !sale.dataset.labelAdded) {
        sale.insertAdjacentHTML('afterbegin', '<span class="visually-hidden">Sale Price </span>');
        sale.dataset.labelAdded = "true";
    }

    if (original && !original.dataset.labelAdded) {
        original.insertAdjacentHTML('afterbegin', '<span class="visually-hidden">Original Price </span>');
        original.dataset.labelAdded = "true";
    }
}

// Observe DOM changes
const observer = new MutationObserver(() => {
    addPriceLabels();
});

// Start observing
observer.observe(document.body, {
    childList: true,
    subtree: true
});

// Also run immediately in case elements already exist
addPriceLabels();
const $tobtn = $('#back-to-top-btn');

// Target element to focus at the top
const $topTarget = $('#main-header').length ? $('#main-header') : $('body');

// Ensure the target is focusable
$topTarget.attr('tabindex', '-1');

// Show/hide button on scroll (30% of page)
$(window).on('scroll', function () {
    const scrollTop = $(this).scrollTop();
    const thirtyPercent = ($(document).height() - $(window).height()) * 0.3;

    if (scrollTop > thirtyPercent) {
        $tobtn.css('display', 'block');   // show
    } else {
        $tobtn.css('display', 'none');    // hide
    }
});

// Click handler
$tobtn.on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 400, function () {
        $topTarget.focus();
    });
});


setTimeout(function() { 
  const $table = $("#tdf_wholesale table");

  if ($table.length) {

    // 1. Add visually hidden caption
    if ($table.find("caption").length === 0) {
      $table.prepend(
        '<caption class="visually-hidden">Quantity discount tiers based on purchase amount</caption>'
      );
    }

    // 2. Treat the first row as a header row (without wrapping in <thead>)
    const $firstRow = $table.find("tbody > tr").first();

    // Add role attributes so screen readers know it's a header row
    $firstRow.attr("role", "row");

    // 3. Add scope="col" to header cells
    $firstRow.find("th").attr("scope", "col");

    // 4. Convert the first <td> in each row into a row header <th scope="row">
    $table.find("tbody tr").each(function (index) {
      if (index === 0) return; // skip header row

      const $firstCell = $(this).find("td").first();

      if ($firstCell.length) {
        const html = $firstCell.html();
        $firstCell.replaceWith(`<th scope="row">${html}</th>`);
      }
    });
  }
  }, 3000);
    });
})(jQuery);
document.addEventListener('DOMContentLoaded', function() {
  // We define a function to initialize our custom control
  function initSlideshowControl() {
    var container = document.querySelector('[data-slideshow-wrapper]');
    // If the container doesn't exist or Flickity isn't loaded yet, retry shortly
    if (!container || !window.Flickity || !Flickity.data(container)) {
      setTimeout(initSlideshowControl, 200);
      return;
    }

    // Get the Flickity instance created by theme.js
    var flkty = Flickity.data(container);
    var btn = document.querySelector('.slideshow-toggle-btn');
    var iconPause = btn.querySelector('.icon-pause');
    var iconPlay = btn.querySelector('.icon-play');

    if(!btn) return;

    // Function to update button icons based on player state
    function updateUIState() {
      // Check internal Flickity player state
      if (flkty.player.state === 'playing') {
        iconPause.style.display = 'block';
        iconPlay.style.display = 'none';
        btn.setAttribute('aria-label', 'Pause slideshow');
      } else {
        iconPause.style.display = 'none';
        iconPlay.style.display = 'block';
        btn.setAttribute('aria-label', 'Play slideshow');
      }
    }

    // Click Event
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation(); // Prevent bubbling

      if (flkty.player.state === 'playing') {
        flkty.stopPlayer(); // Permanently stop
      } else {
        flkty.playPlayer(); // Resume autoplay
      }
      updateUIState();
    });

    // Listen for manual interaction (dragging/touching)
    // theme.js automatically pauses on 'pointerDown', so we just need to update UI
    flkty.on('pointerDown', function() {
      setTimeout(updateUIState, 50); // Small delay to let theme.js fire first
    });
    
    // Initial UI check
    updateUIState();
  }

  // Initialize
  initSlideshowControl();
});


